import { Controller } from "@hotwired/stimulus"

// Drives the admin community cover-image field. Two jobs:
//
//  1. Instant local preview the moment a file is chosen (FileReader → data URL).
//  2. A progress bar fed by Rails' Active Storage direct-upload events, which
//     fire on the <input> while the form submits (the file streams straight to
//     S3 before the record saves). This is what lets an admin watch the upload.
//
// We preventDefault the error event so @rails/activestorage does NOT fall back
// to its blocking alert() dialog (blocked by our CSP / dialog rules).
export default class extends Controller {
  static targets = [
    "input", "previewImage", "placeholder",
    "progressWrap", "bar", "pct", "prompt"
  ]

  connect() {
    this._onInit = this.onInit.bind(this)
    this._onProgress = this.onProgress.bind(this)
    this._onError = this.onError.bind(this)
    this._onEnd = this.onEnd.bind(this)

    const el = this.inputTarget
    el.addEventListener("direct-upload:initialize", this._onInit)
    el.addEventListener("direct-upload:progress", this._onProgress)
    el.addEventListener("direct-upload:error", this._onError)
    el.addEventListener("direct-upload:end", this._onEnd)
  }

  disconnect() {
    const el = this.inputTarget
    el.removeEventListener("direct-upload:initialize", this._onInit)
    el.removeEventListener("direct-upload:progress", this._onProgress)
    el.removeEventListener("direct-upload:error", this._onError)
    el.removeEventListener("direct-upload:end", this._onEnd)
  }

  // Local preview as soon as a file is selected.
  preview() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (!file) return

    if (this.hasPromptTarget) this.promptTarget.textContent = file.name

    const reader = new FileReader()
    reader.onload = (e) => {
      if (this.hasPreviewImageTarget) {
        this.previewImageTarget.src = e.target.result
        this.previewImageTarget.style.display = "block"
      }
      if (this.hasPlaceholderTarget) this.placeholderTarget.style.display = "none"
    }
    reader.readAsDataURL(file)
  }

  onInit() {
    if (this.hasBarTarget) this.barTarget.classList.remove("cover-upload__bar--error")
    this.setProgress(0)
    if (this.hasProgressWrapTarget) this.progressWrapTarget.hidden = false
  }

  onProgress(event) {
    this.setProgress(Math.round(event.detail.progress))
  }

  onError(event) {
    // Suppress @rails/activestorage's default alert() dialog.
    event.preventDefault()
    if (this.hasPctTarget) this.pctTarget.textContent = "Upload failed"
    if (this.hasBarTarget) this.barTarget.classList.add("cover-upload__bar--error")
  }

  onEnd() {
    this.setProgress(100)
  }

  setProgress(pct) {
    if (this.hasBarTarget) this.barTarget.style.width = `${pct}%`
    if (this.hasPctTarget) this.pctTarget.textContent = `${pct}%`
  }
}
